export class SubnetsCondition {
    'operator';
    'subnets';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ListOperators",
            "format": ""
        },
        {
            "name": "subnets",
            "baseName": "subnets",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SubnetsCondition.attributeTypeMap;
    }
    constructor() {
    }
}
